import { Box, Slider, Text } from './';

export const BoxSlider = ({ value, height=300, disabled = false, onChange, label, labelStyle ={}, styleContainer = {}, styleSlider = {}, ...props }) => {
    return (
        <>
            <Box sx={[styles.container, { ...styleContainer, height: "100%" }]}>
                <Box sx={{ height: "100%" }}>
                    <Slider
                        sx={{
                        '& input[type="range"]': {
                            WebkitAppearance: 'slider-vertical',
                        },
                        '& .MuiSlider-valueLabel': {
                            fontSize: 14,
                            fontWeight: 'bold',
                            left: 32,
                            backgroundColor: 'unset',
                            color: "#000",
                            '&:before': {
                                display: 'none',
                            },
                            '& *': {
                                background: 'transparent',
                                color: '#000',
                            },
                        },
                        height: "100%",
                        ...styleSlider
                        }}
                        orientation="vertical"
                        value={value}
                        valueLabelDisplay="on"
                        disabled={disabled}
                        onChange={onChange}
                        {...props}
                    />
                </Box>
                {label && 
                    <Text style={{ width: "100%", ...labelStyle}}>{label}</Text>
                }
            </Box>
        </>
    );
}

const styles = {
    container: {
        
        margin: '2px 20px',
        width: 90,
        textAlign: 'center'
    }
}